import Vue from "../../../../node_modules/vue/dist/vue.js";
import SignaturePad from "../../../../node_modules/signature_pad/dist/signature_pad.umd.js";
import {docReady} from '../theme/events';

docReady(() => {
    (function($) {
        Vue.config.devtools = window.magiclineSignupConfig.devtools;

        var StepDirections = {
            FORWARD: 'forward',
            BACKWARD: 'backward',
            NEUTRAL: 'neutral'
        };

        var signupFormSelector = '[data-role="signup-form"]';
        var signupForm = document.querySelector(signupFormSelector);

        // FORM EXISTENCE CHECK
        if (!signupForm) {
            return;
        }

        // SIGNUP FORM VUE.JS!
        var signup = new Vue({
            el: signupFormSelector,
            data: {
                storageKey: window.magiclineSignupConfig.storage_key,
                storageVersion: parseInt(window.magiclineSignupConfig.storage_version),
                maxSteps: 7,
                step: 1,
                studios: null,
                studioSorting: 1,
                selectedStudioId: null,
                rateBundles: null,
                rateBundleImage: 0,
                selectedRateBundleId: null,
                selectedModuleIds: [],
                selectedSelectableModuleIds: [],
                selectedOptionalModuleIds: [],
                selectedTermId: null,
                genders: {
                    MALE: 'Männlich',
                    FEMALE: 'Weiblich',
                    UNISEX: 'Divers'
                },
                errors: {},
                personalData: {
                    firstName: '',
                    lastName: '',
                    birthDate: '',
                    gender: '',
                    email: '',
                    emailConfirm: '',
                    phoneNo: '',
                    street: '',
                    houseNo: '',
                    zipCode: '',
                    city: ''
                },
                paymentData: {
                    accountHolder: '',
                    iban: '',
                    accountHolderValid: false,
                    ibanValid: false,
                    bic: '',
                    agreed: false
                },
                sepaAgreement: '',
                sepaSignatureRequired: true,
                sepaSignaturePad: null,
                sepaSignatureData: null,
                sepaSignatureDataUrl: null,
                contractSignaturePad: null,
                contractSignatureData: null,
                contractSignatureDataUrl: null,
                createdCustomer: null,
                creatingCustomer: false,
                finished: false
            },
            beforeMount: function () {
                this.restore();

                this.goToStep(1);
            },
            mounted: function () {
                //mounted
            },
            beforeUpdate: function () {
                //beforeUpdate
            },
            computed: {
                selectedStudio: function () {
                    if (!this.studios) {
                        return null;
                    }

                    return this.studios.find(function (studio) {
                        return studio.id === this.selectedStudioId;
                    }, this);
                },
                selectedRateBundle: function () {
                    if (!this.rateBundles) {
                        return null;
                    }

                    return this.rateBundles.find(function (rateBundle) {
                        return rateBundle.id === this.selectedRateBundleId;
                    }, this);
                },
                selectedTerm: function () {
                    if (!this.selectedRateBundle) {
                        return null;
                    }

                    return this.selectedRateBundle.terms.find(function (term) {
                        return term.id === this.selectedTermId;
                    }, this);
                },
                hasSelectableModules: function () {
                    if (!this.selectedRateBundle) {
                        return false;
                    }

                    return this.selectedRateBundle.selectableModules.length
                },
                hasOptionalModules: function () {
                    if (!this.selectedTerm) {
                        return false;
                    }

                    return this.selectedTerm.optionalModules.length;
                }
            },
            methods: {
                germanDateString(dateString) {
                    return new Date(dateString).toLocaleDateString('de-DE');
                },
                paymentFrequencyLocalized(paymentFrequencyUnit) {
                    if (paymentFrequencyUnit === 'MONTH') {
                        return 'monatlich';
                    } else if (paymentFrequencyUnit === 'YEAR') {
                        return 'jährlich';
                    }

                    return '';
                },
                termUnitLocalized(termValue, termUnit) {
                    if (termUnit === 'MONTH') {
                        return termValue == 1 ? 'Monat' : 'Monate';
                    } else if (termUnit === 'YEAR') {
                        return termValue == 1 ? 'Jahr' : 'Jahre';
                    }

                    return '';
                },
                priceLocalized(price) {
                    return parseFloat(price).toFixed(2).replace('.', ',') + ' €';
                },
                greater(currentStep, compareStep) {
                    return currentStep > compareStep;
                },
                sanitizeStepValue: function (stepValue) {
                    if (stepValue < 1) {
                        return 1;
                    }

                    if (stepValue > this.maxSteps) {
                        return this.maxSteps;
                    }

                    return stepValue;
                },
                nextStep: function () {
                    this.goToStep(this.step + 1);
                },
                previousStep: function () {
                    this.goToStep(this.step - 1);
                },
                getSteppingDirection: function (newStep, currentStep) {
                    if (newStep > currentStep) {
                        return StepDirections.FORWARD;
                    }

                    if (newStep < currentStep) {
                        return StepDirections.BACKWARD;
                    }

                    return StepDirections.NEUTRAL;
                },
                goToStep: function (step) {
                    var self = this;

                    if (this.finished) {
                        console.log('skipping step navigation because signup is already finished');
                        return;
                    }

                    step = this.sanitizeStepValue(step);
                    var url = new URL(window.location.href);
                    var direction = this.getSteppingDirection(step, this.step);

                    //validate all steps from the first, if we encounter any invalid steps navigate there
                    console.log('validating all previous steps 1 through ' + step);

                    for (var i = 1; i < step; i++) {
                        // this.removeAllErrors();
                        var stepValid = this.validateStep(i);

                        if (!stepValid) {
                            direction = this.getSteppingDirection(i, this.step);
                            console.log('step ' + i + ' is not valid, navigating there (direction: ' + direction + ')');
                            this.setStep(i, direction);

                            return;
                        }
                    }

                    console.log('all steps up to step ' + step + ' are valid, navigating there (direction: ' + direction + ')');
                    this.setStep(step, direction);
                },
                setStep: function (step, direction) {
                    this.beforeStep(step, direction);
                    this.step = step;
                    this.afterStep(step, direction);
                },
                beforeStep: function (step, direction) {
                    console.log('before step ' + step + ' callback (direction: ' + direction + ')');

                    switch (step) {
                        case 1:
                            this.getStudios();
                            break;
                        case 2:
                            this.getRateBundles();
                            break;
                        case 6:
                            this.getPreview();
                            break;
                        case 7:
                            this.createCustomerAndContract();
                            break;
                    }
                },
                afterStep: function (step, direction) {
                    console.log('after step ' + step + ' callback (direction: ' + direction + ')');

                    switch (step) {
                        case 3:
                            this.skipModulesIfNonAvailable(direction);
                            break;
                        case 5:
                            this.initSepaSignaturePad();
                            break;
                        case 6:
                            this.initContractSignaturePad();
                            break;
                    }
                },
                getCssRootProperty: function(property, fallback) {
                    var style = window.getComputedStyle(document.body)

                    return style.getPropertyValue(property) || fallback;
                },
                initSepaSignaturePad: function () {
                    var self = this;

                    if (this.sepaSignatureRequired) {
                        this.$nextTick(function () {
                            //init signature pad
                            self.sepaSignaturePad = new SignaturePad(self.$refs.sepaSignature, {
                                backgroundColor: self.getCssRootProperty('--se-lighter', 'rgb(255, 255, 255)'),
                                penColor: self.getCssRootProperty('--se-dark', 'rgb(226, 28, 35)'),
                            });

                            //clear signature button
                            self.$refs.sepaSignatureClear.addEventListener('click', function (event) {
                                self.sepaSignaturePad.clear();
                                self.sepaSignatureData = null;
                                self.sepaSignatureDataUrl = null;
                            });

                            //restore previous signature if already signed
                            if (self.sepaSignatureData) {
                                self.sepaSignaturePad.fromData(self.sepaSignatureData);
                            }

                            //save signature data on stroke end
                            this.sepaSignaturePad.addEventListener('endStroke', function () {
                                if (self.sepaSignaturePad.isEmpty()) {
                                    self.sepaSignatureData = null;
                                    self.sepaSignatureDataUrl = null;
                                } else {
                                    self.sepaSignatureData = self.sepaSignaturePad.toData();
                                    self.sepaSignatureDataUrl = self.sepaSignaturePad.toDataURL('image/svg+xml');
                                }
                            });
                        });
                    } else {
                        //signature is not required, so we skip this step and reset
                        console.log('skipping sepa signature because it is not required');
                        self.sepaSignaturePad = null;
                        self.sepaSignatureData = null;
                        self.sepaSignatureDataUrl = null;
                    }
                },
                initContractSignaturePad: function () {
                    var self = this;

                    if (this.selectedRateBundle.contractSignaturesRequired) {
                        this.$nextTick(function () {
                            //init signature pad
                            self.contractSignaturePad = new SignaturePad(self.$refs.contractSignature, {
                                backgroundColor: self.getCssRootProperty('--se-lighter', 'rgb(255, 255, 255)'),
                                penColor: self.getCssRootProperty('--se-dark', 'rgb(226, 28, 35)'),
                            });

                            //clear signature button
                            self.$refs.contractSignatureClear.addEventListener('click', function (event) {
                                self.contractSignaturePad.clear();
                                self.contractSignatureData = null;
                                self.contractSignatureDataUrl = null;
                            });

                            //restore previous signature if already signed
                            if (self.contractSignatureData) {
                                self.contractSignaturePad.fromData(self.contractSignatureData);
                            }

                            //save signature data on stroke end
                            this.contractSignaturePad.addEventListener('endStroke', function () {
                                if (self.contractSignaturePad.isEmpty()) {
                                    self.contractSignatureData = null;
                                    self.contractSignatureDataUrl = null;
                                } else {
                                    self.contractSignatureData = self.contractSignaturePad.toData();
                                    self.contractSignatureDataUrl = self.contractSignaturePad.toDataURL('image/svg+xml');
                                }
                            });
                        });
                    } else {
                        //signature is not required, so we skip this step and reset
                        console.log('skipping contract signature because it is not required');
                        self.contractSignaturePad = null;
                        self.contractSignatureData = null;
                        self.contractSignatureDataUrl = null;
                    }
                },
                getStudios: function () {
                    var self = this;
                    var success = function (data) {
                        console.log('getStudios', data);
                        self.studios = data;
                    };
                    var error = function (xhr, status, error) {
                    };
                    var beforeSend = function () {
                    };

                    this.consumeMagiclineApi('GET', '/v2/studio', {}, success, error, beforeSend);
                },
                getRateBundles: function () {
                    var self = this;
                    var success = function (data) {
                        console.log('getRateBundles', data);
                        self.rateBundles = data;
                    };
                    var error = function (xhr, status, error) {
                    };
                    var beforeSend = function () {
                    };

                    this.consumeMagiclineApi('GET', '/v1/rate-bundle', {studioId: this.selectedStudioId}, success, error, beforeSend);
                },
                getSepaAgreement: function () {
                    var self = this;
                    var success = function (data) {
                        console.log('getSepaAgreement', data);
                        self.sepaAgreement = data;
                    };
                    var error = function (xhr, status, error) {
                    };
                    var beforeSend = function () {
                    };

                    this.consumeMagiclineApi('GET', '/v1/studio/' + this.selectedStudioId + '/sepa/agreement', {}, success, error, beforeSend);
                },
                validateAccountHolderName: function () {
                    var self = this;
                    var success = function (data) {
                        console.log('validateAccountHolderName', data);
                        self.paymentData.accountHolderValid = data.valid;
                        self.save();
                    };
                    var error = function (xhr, status, error) {
                    };
                    var beforeSend = function () {
                    };

                    this.consumeMagiclineApi('GET', '/v1/bankaccount/validate/accountholder', {accountHolder: this.paymentData.accountHolder}, success, error, beforeSend);
                },
                validateIbanAndLookupBic: function () {
                    var self = this;
                    var success = function (data) {
                        console.log('validateIbanAndLookupBic', data);
                        self.paymentData.ibanValid = data.validIban;
                        self.paymentData.bic = data.bic;
                        self.save();
                    };
                    var error = function (xhr, status, error) {
                    };
                    var beforeSend = function () {
                    };

                    this.consumeMagiclineApi('GET', '/v1/bankaccount', {iban: this.paymentData.iban}, success, error, beforeSend);
                },
                getPreview: function () {
                    var self = this;
                    var success = function (data) {
                        self.removeError('preview-not-created');

                        console.log('getPreview', data);
                    };
                    var error = function (xhr, status, error) {
                        self.addLocalErrors([
                            {
                                id: 'preview-not-created',
                                message: 'Ein Fehler ist aufgetreten. Bitte versuche es erneut',
                                type: 'danger'
                            }
                        ]);
                    };
                    var beforeSend = function () {
                        self.removeError('preview-not-created');
                    };

                    this.consumeMagiclineApi('POST', '/v1/preview', JSON.stringify(this.getCompiledData()), success, error, beforeSend);
                },
                createCustomerAndContract: function () {
                    var self = this;
                    var success = function (data) {
                        self.createdCustomer = data;
                        self.creatingCustomer = false;
                        self.finished = true;

                        self.removeError('contract-not-created');

                        console.log('createCustomerAndContract', data);
                    };
                    var error = function (xhr, status, error) {
                        self.creatingCustomer = false;
                        self.createdCustomer = null;

                        self.addLocalErrors([
                            {
                                id: 'contract-not-created',
                                message: 'Der Vertrag konnte nicht erstellt werden. Bitte versuche es erneut.',
                                type: 'danger'
                            }
                        ]);

                        self.previousStep();
                    };
                    var beforeSend = function () {
                        self.creatingCustomer = true;

                        self.removeError('contract-not-created');
                    };

                    this.consumeMagiclineApi('POST', '/v1/rate-bundle', JSON.stringify(this.getCompiledData()), success, error, beforeSend);
                },
                getCompiledData: function () {
                    var self = this;

                    var selectedRateBundleModules = this.selectedSelectableModuleIds.map(function (moduleId) {
                        return {
                            id: moduleId
                        };
                    });

                    var optionalRateBundleTermModules = this.selectedOptionalModuleIds.map(function (moduleId) {
                        return {
                            id: moduleId
                        }
                    });

                    var textBlockSignatures = this.selectedRateBundle.contractTextBlocks.map(function (textBlock) {
                        return {
                            textBlockId: textBlock.id,
                            base64Svg: ""
                        }
                    });

                    var data = {};

                    data.studioId = self.selectedStudioId;
                    data.contract = {
                        startDate: new Date().toISOString().slice(0, 10),
                        rateBundleTermId: self.selectedTermId,
                        optionalRateBundleTermModules: optionalRateBundleTermModules
                    };
                    data.customer = {
                        firstname: self.personalData.firstName,
                        lastname: self.personalData.lastName,
                        dateOfBirth: self.personalData.birthDate,
                        email: self.personalData.email,
                        gender: self.personalData.gender,
                        street: self.personalData.street,
                        houseNumber: self.personalData.houseNo,
                        city: self.personalData.city,
                        zipCode: self.personalData.zipCode,
                        telephone_private: self.personalData.phoneNo,
                        countryCode: 'DE',
                        studioCountryCode: 'DE',
                        paymentChoice: 'DIRECT_DEBIT', //allowed can be found here self.selectedRateBundle.allowedPaymentChoices
                        bankAccount: {
                            iban: self.paymentData.iban.replace(/\s/g, ''),
                            accountHolder: self.paymentData.accountHolder
                        }
                    }

                    //add signatures
                    data.contract.contractSignature = {
                        base64Svg: this.contractSignatureDataUrl ?? ""
                    };

                    data.contract.sepaSignature = {
                        base64Svg: this.sepaSignatureDataUrl ?? ""
                    };

                    return data;
                },
                selectStudio: function () {
                    //when changing the studio we rest stuff that is
                    //inherently bound to the selected studio
                    this.selectedRateBundleId = null;
                    this.selectedModuleIds = [];
                    this.selectedSelectableModuleIds = [];
                    this.selectedOptionalModuleIds = [];
                    this.selectedTermId = null;
                    this.removeError('studio-not-selected');
                    this.$forceUpdate();
                    this.getSepaAgreement();
                },
                selectRateBundle: function () {
                    var self = this;
                    this.selectedTermId = null;
                    this.selectedModuleIds = [];
                    this.selectedSelectableModuleIds = [];
                    this.selectedOptionalModuleIds = [];
                    this.removeError('rate-not-selected');

                    this.selectedRateBundle.modules.forEach(function (module) {
                        if (self.isFreeModule(module)) {
                            self.selectedModuleIds.push(module.id);
                        }
                    });

                    this.$forceUpdate();
                },
                isFreeModule: function (module) {
                    return module.paymentFrequencyType === 'FREE';
                },
                selectTerm: function () {
                    this.selectedOptionalModuleIds = [];
                    this.removeError('term-not-selected');
                    this.$forceUpdate();
                },
                consumeMagiclineApi: function (method, endpoint, params, successCallback, errorCallback, beforeSendCallback) {
                    var tenantName = 'studio-enjoy';

                    var self = this;

                    params = params || {};
                    method = method || 'GET';
                    successCallback = successCallback || function (data) {
                    };
                    beforeSendCallback = beforeSendCallback || function () {
                    };
                    errorCallback = errorCallback || function (xhr, status, error) {
                        console.error(error);
                    };
                    endpoint = endpoint.replace(/^\/+/g, ''); //remove leading slashes

                    console.log('consuming api endpoint "' + endpoint + '"');

                    if (this.finished) {
                        console.log('skipping api call because signup is already finished');
                        return;
                    }

                    $.ajax({
                        url: 'https://' + tenantName + '.api.magicline.com/connect/' + endpoint,
                        method: method,
                        data: params,
                        dataType: 'json',
                        contentType: 'application/json',
                        beforeSend: function () {
                            console.log('beforeSend api endpoint "' + endpoint + '"');
                            beforeSendCallback();
                        },
                        success: function (data) {
                            console.log('success api endpoint "' + endpoint + '"');
                            successCallback(data);
                        },
                        error: function (xhr, status, error) {
                            console.error('error api endpoint "' + endpoint + '"');

                            if (xhr.responseJSON) {
                                console.error(xhr.responseJSON.message);

                                var errors = [];
                                xhr.responseJSON.errorCodes.forEach(function (errorCode) {
                                    errors.push({
                                        id: 'api-' + errorCode,
                                        message: self.getErrorCodeMessage(errorCode),
                                        type: 'danger'
                                    });
                                });
                                console.log('errors', errors);
                                self.addLocalErrors(errors);
                            }

                            errorCallback(xhr, status, error);
                        }
                    });
                },
                getErrorCodeMessage: function (errorCode) {
                    //list from here: https://developer.magicline.com/apis/connectapi/reference/operation/getRateBundleList/#tag/Contracts/operation/getRateBundleList!c=400&path=0/errorCodes&t=response
                    switch (errorCode) {
                        case 'ENTITY_NOT_FOUND':
                            return 'Die angeforderte Ressource wurde nicht gefunden.';
                        case 'CONFLICT':
                            return 'Die angeforderte Aktion kann nicht ausgeführt werden, da sie einen Konflikt mit einer anderen Ressource verursachen würde.';
                        case 'BAD_REQUEST':
                            return 'Die Anfrage ist fehlerhaft.';
                        case 'REQUIRED_PARAMETER_MISSING':
                            return 'Es fehlen benötigte Parameter.';
                        case 'VALIDATION_FAILED':
                            return 'Ein oder mehrere Angaben sind fehlerhaft. Bitte überprüfe deine Eingaben.';
                        case 'FORBIDDEN':
                            return 'Die angeforderte Aktion ist nicht erlaubt.';
                        case 'OPERATION_NOT_ALLOWED_FOR_STUDIO':
                            return 'Die angeforderte Aktion ist nicht erlaubt.';
                        case 'SERVER_ERROR':
                            return 'Ein Server Fehler ist aufgetreten.';
                        case 'FEATURE_DISABLED':
                            return 'Die angeforderte Aktion ist nicht erlaubt.';
                        case 'STUDIO_NOT_IN_GERMANY':
                            return 'Die angeforderte Aktion ist nicht erlaubt.';
                        case 'VOUCHER_VALIDATION_FAILED_INVALID_CODE':
                            return 'Der angegebene Gutscheincode ist ungültig.';
                        case 'VOUCHER_VALIDATION_FAILED_NOT_REDEEMABLE_HERE':
                            return 'Der angegebene Gutscheincode ist nicht für dieses Studio gültig.';
                        case 'VOUCHER_VALIDATION_FAILED_NOT_IN_VALIDITY_PERIOD':
                            return 'Der angegebene Gutscheincode ist nicht mehr gültig.';
                        case 'VOUCHER_VALIDATION_FAILED_NOT_ALLOWED_FOR_RATE':
                            return 'Der angegebene Gutscheincode ist nicht für diese Mitgliedschaft gültig.';
                        case 'TRIALSESSION_ALREADY_BOOKED':
                            return 'Du hast bereits eine kostenlose Probestunde gebucht.';
                        default:
                            return 'Ein Fehler ist aufgetreten.';
                    }
                },
                validateStep: function (step) {
                    console.log('validating step ' + step);

                    var self = this;

                    switch (step) {
                        case 1:
                            return this.validateStudio();
                        case 2:
                            return this.validateRate();
                        case 3:
                            return this.validateModules();
                        case 4:
                            return this.validatePersonalData();
                        case 5:
                            return this.validatePaymentData();
                        case 6:
                            return this.validateSummary();
                        case 7:
                            return this.validateConfirmation();
                        default:
                            return true;
                    }
                },
                validateStudio: function () {
                    var errors = [];

                    if (!this.selectedStudioId) {
                        errors.push({
                            id: 'studio-not-selected',
                            message: 'Bitte wähle ein Studio aus.',
                            type: 'danger'
                        });
                    } else {
                        this.removeError('studio-not-selected');
                    }

                    this.addLocalErrors(errors);

                    return errors.length === 0;
                },
                validateRate: function () {
                    var errors = [];

                    if (!this.selectedRateBundleId) {
                        errors.push({
                            id: 'rate-not-selected',
                            message: 'Bitte wähle eine Mitgliedschaft aus.',
                            type: 'danger'
                        })
                    } else {
                        this.removeError('rate-not-selected');
                    }

                    if (!this.selectedTermId) {
                        errors.push({
                            id: 'term-not-selected',
                            message: 'Bitte wähle eine Laufzeit aus.',
                            type: 'danger'
                        });
                    } else {
                        this.removeError('term-not-selected');
                    }

                    this.addLocalErrors(errors);

                    return errors.length === 0;
                },
                validateModules: function () {
                    var errors = [];

                    this.addLocalErrors(errors);

                    return errors.length === 0;
                },
                validatePersonalData: function () {
                    var errors = [];
                    var self = this;

                    for (var property in this.personalData) {
                        if (!this.personalData[property]) {
                            errors.push({
                                id: 'personal-data-' + property + '-not-set',
                                message: 'Bitte fülle ' + self.translateProperty(property) + ' aus.',
                                type: 'danger'
                            });
                        } else {
                            this.removeError('personal-data-' + property + '-not-set');
                        }
                    }

                    if (this.personalData.email !== this.personalData.emailConfirm) {
                        errors.push({
                            id: 'personal-data-emails-dont-match',
                            message: 'Die E-Mail Adressen stimmen nicht überein.',
                            type: 'danger'
                        });
                    } else {
                        this.removeError('personal-data-emails-dont-match');
                    }

                    this.addLocalErrors(errors);

                    return errors.length === 0;
                },
                validatePaymentData: function () {
                    var errors = [];
                    var self = this;

                    for (var property in this.paymentData) {
                        if (['accountHolder', 'iban'].includes(property) && !this.paymentData[property]) {
                            errors.push({
                                id: 'payment-data-' + property + '-not-set',
                                message: 'Bitte fülle ' + self.translateProperty(property) + ' aus.',
                                type: 'danger'
                            })
                        } else {
                            this.removeError('payment-data-' + property + '-not-set');
                        }
                    }

                    if (!this.paymentData.ibanValid) {
                        errors.push({
                            id: 'payment-data-iban-invalid',
                            message: 'Die IBAN ist ungültig.',
                            type: 'danger'
                        });
                    } else {
                        this.removeError('payment-data-iban-invalid');
                    }

                    if (!this.paymentData.accountHolderValid) {
                        errors.push({
                            id: 'payment-data-account-holder-invalid',
                            message: 'Der Kontoinhaber ist ungültig.',
                            type: 'danger'
                        });
                    } else {
                        this.removeError('payment-data-account-holder-invalid');
                    }

                    if (!this.paymentData.agreed) {
                        errors.push({
                            id: 'payment-data-agreement-not-accepted',
                            message: 'Sie müssen dem Einzug mittels Lastschrift zustimmen.',
                            type: 'danger'
                        });
                    } else {
                        this.removeError('payment-data-agreement-not-accepted');
                    }

                    if (this.sepaSignatureRequired && this.sepaSignatureDataUrl === null) {
                        errors.push({
                            id: 'sepa-signature-not-set',
                            message: 'Bitte unterschreibe das SEPA-Lastschriftmandat.',
                            type: 'danger'
                        });
                    } else {
                        this.removeError('sepa-signature-not-set');
                    }

                    this.addLocalErrors(errors);

                    return errors.length === 0;
                },
                validateSummary: function () {
                    var errors = [];

                    if (this.selectedRateBundle.contractSignaturesRequired && this.contractSignatureDataUrl === null) {
                        errors.push({
                            id: 'contract-signature-not-set',
                            message: 'Bitte unterschreibe den Vertrag.',
                            type: 'danger'
                        });
                    } else {
                        this.removeError('contract-signature-not-set');
                    }

                    this.addLocalErrors(errors);

                    return errors.length === 0;
                },
                validateConfirmation: function () {
                    var errors = [];

                    this.addLocalErrors(errors);

                    return errors.length === 0;
                },
                canPreviousStep: function () {
                    return this.step > 1 && !this.finished;
                },
                canNextStep: function () {
                    return this.step < this.maxSteps && !this.finished;
                },
                canConfirmStep: function () {
                    return this.step === this.maxSteps && !this.finished;
                },
                skipModulesIfNonAvailable: function (direction) {
                    if (!this.hasOptionalModules) {
                        console.log('skipping modules (step 3) because there are no optional modules');
                        if (direction === StepDirections.FORWARD) {
                            this.goToStep(4);
                        } else if (direction === StepDirections.BACKWARD) {
                            this.goToStep(2);
                        }
                    }
                },
                addError: function (id, message, type) {
                    this.errors[id] = {
                        message: message,
                        type: type,
                        cls: 'alert-' + type
                    }
                },
                removeError: function (id) {
                    if (this.hasError(id)) {
                        delete this.errors[id];

                        console.log('removing error', id);

                        this.$forceUpdate();
                    }
                },
                removeAllErrors: function () {
                    this.errors = {};

                    this.$forceUpdate();
                },
                addLocalErrors: function (errors) {
                    if (!errors) {
                        return;
                    }

                    console.log('adding local errors', errors);

                    errors.forEach(function (error) {
                        this.addError(error.id, error.message, error.type);
                    }, this);

                    this.$forceUpdate();
                },
                hasError: function (id) {
                    return this.errors.hasOwnProperty(id);
                },
                hasPersonalDataError: function (property) {
                    return this.hasError('personal-data-' + property + '-not-set');
                },
                removePersonalDataError: function (property) {
                    this.removeError('personal-data-' + property + '-not-set');
                },
                hasPaymentDataError: function (property) {
                    return this.hasError('payment-data-' + property + '-not-set');
                },
                removePaymentDataError: function (property) {
                    this.removeError('payment-data-' + property + '-not-set');
                },
                translateProperty: function (property) {
                    switch (property) {
                        case 'firstName':
                            return 'Vorname';
                        case 'lastName':
                            return 'Nachname';
                        case 'birthDate':
                            return 'Geburtsdatum';
                        case 'gender':
                            return 'Geschlecht';
                        case 'email':
                            return 'E-Mail';
                        case 'emailConfirm':
                            return 'E-Mail Bestätigung';
                        case 'phoneNo':
                            return 'Telefonnummer';
                        case 'street':
                            return 'Straße';
                        case 'houseNo':
                            return 'Hausnummer';
                        case 'zipCode':
                            return 'Postleitzahl';
                        case 'city':
                            return 'Stadt';
                        case 'accountHolder':
                            return 'Kontoinhaber';
                        case 'iban':
                            return 'IBAN';
                        default:
                            return property;
                    }
                },
                save: function () {
                    var self = this;

                    saveObj = {
                        timestamp: Date.now() / 1000,
                        data: {
                            v: this.storageVersion,
                            personalData: this.personalData,
                            paymentData: this.paymentData,
                            contractSignatureData: this.contractSignatureData,
                            contractSignatureDataUrl: this.contractSignatureDataUrl,
                            sepaSignatureData: this.sepaSignatureData,
                            sepaSignatureDataUrl: this.sepaSignatureDataUrl
                        }
                    };

                    localStorage.setItem(self.storageKey, JSON.stringify(saveObj));
                },
                restore: function () {
                    var self = this;

                    if (localStorage.getItem(self.storageKey) !== null) {
                        var saveObj = JSON.parse(localStorage.getItem(self.storageKey)),
                            now = Date.now() / 1000;

                        if ((now - saveObj.timestamp) > 3600 || typeof saveObj.timestamp === "undefined") {
                            localStorage.removeItem(self.storageKey);
                        } else {
                            if ('v' in saveObj.data && parseInt(saveObj.data.v) === parseInt(window.magiclineSignupConfig.storage_version)) {
                                self.personalData = saveObj.data.personalData;
                                self.paymentData = saveObj.data.paymentData;
                                self.contractSignatureData = saveObj.data.contractSignatureData;
                                self.contractSignatureDataUrl = saveObj.data.contractSignatureDataUrl;
                                self.sepaSignatureData = saveObj.data.sepaSignatureData;
                                self.sepaSignatureDataUrl = saveObj.data.sepaSignatureDataUrl;
                            } else {
                                localStorage.removeItem(self.storageKey);
                            }
                        }
                    }
                },
            }
        })
    })(jQuery)
});
